import type { CmmsRecordType } from './cmmsRecordTypes'
import type { WorkOrderEntry } from './workOrder'

const MAXIMO_APPLICATIONS: Partial<
  Record<CmmsRecordType, { application: string; idField: string }>
> = {
  'cmms-work-order': { application: 'WOTRACK', idField: 'workorderid' },
  'cmms-asset': { application: 'ASSET', idField: 'assetuid' },
  'cmms-location': { application: 'LOCATION', idField: 'locationsid' },
  'cmms-item': { application: 'ITEM', idField: 'itemid' },
  'cmms-stock': { application: 'INVENTOR', idField: 'inventoryid' },
  'cmms-inventory-usage': { application: 'INVUSAGE', idField: 'invuseid' },
  'cmms-purchase-order': { application: 'PO', idField: 'poid' },
  'cmms-purchase-requisition': { application: 'PR', idField: 'prid' },
  'cmms-vendor': { application: 'COMPANY', idField: 'companiesid' },
  'cmms-pm': { application: 'PM', idField: 'pmuid' },
  'cmms-job-plan': { application: 'JOBPLAN', idField: 'jobplanid' },
}

export function cmmsNativeLink(entry: WorkOrderEntry): string | undefined {
  const { source, record } = entry.data
  if (source.system.toLowerCase() !== 'maximo') return undefined
  const host = source.host.toLowerCase()
  if (
    !/^(?=.{1,253}$)(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/.test(
      host
    ) ||
    !host.includes('.manage.')
  )
    return undefined
  const target = MAXIMO_APPLICATIONS[entry.type]
  if (!target) return undefined
  const value = record[target.idField]
  if (
    (typeof value !== 'string' && typeof value !== 'number') ||
    !/^[1-9]\d*$/.test(String(value))
  )
    return undefined
  const url = new URL(
    `https://${host}/maximo/oslc/graphite/manage-shell/index.html`
  )
  url.searchParams.set('event', 'loadapp')
  url.searchParams.set('value', target.application)
  url.searchParams.set('uniqueid', String(value))
  return url.toString()
}
